
/**
 * Вычисляет возраст по дате
 * @param {string} dateString
 * @return {number}
 */
export function calcAge(dateString: string): number {
    const birthday = (new Date(dateString)).getTime();
    const yearMs = 365 * 24 * 60 * 60 * 1000; // 365 days * 24 hours * 60 min * 60 secs * 1000 ms in second
    let result = Math.trunc((Date.now() - birthday) / (yearMs));


    if (result < 0) {
        /* TODO переделать, result должен быть number
           @ts-ignore */
        result = '';
        window.Sentry.captureMessage('Calc age < 0');
    }

    return result;
}

/**
 * Рекурсивный обход
 * @param {object} obj Объект обхода
 * @param {callback} handler
 * @param {callback} notFoundCallback
 *
 * @param endFlag
 * @callback handler
 * @param {object} obj Объект родитель key:value
 *
 * @callback notFoundCallback
 * */
export function find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj: { [key: string]: any },
    handler: Function,
    notFoundCallback: Function,
    inEndFlag: boolean = false
) {
    let endFlag = inEndFlag ? inEndFlag : false;
    let key: string;

    for (key in obj) {
        if (typeof (obj[key]) === 'object') {
            find(obj[key], handler, notFoundCallback, endFlag);
        } else {
            if (handler(key, obj[key], obj) === false) {
                endFlag = true;
                break;
            }
        }
    }
    if (!endFlag && typeof notFoundCallback !== 'undefined') {
        notFoundCallback();
    }
}

/**
 * Разбить по Int
 * @param {object} obj
 * @param {number} size
 * */
export function chunk(obj: {[key: string]: object}, size: number) {
    let k = 0;
    let i = 1;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any[][] = [[]];
    let key: string;

    for (key in obj) {
        if (i > size) {
            k += 1;
            i = 1;
            result[k] = [];
        }
        result[k].push(obj[key]);
        i += 1;
    }

    return result;
}

export function getParameterByName(name: string, url: string) {
    let regex, results;

    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function isTestMode(): boolean {
    return !(parseInt(window.app.config.test_mode) === 0);
}
